// Достаёт человекочитаемый текст из huma ErrorModel / Error / unknown.
export function errorMessage(error: unknown): string {
  if (error == null) return 'Неизвестная ошибка'
  if (typeof error === 'object') {
    const e = error as { detail?: unknown; title?: unknown; message?: unknown }
    if (typeof e.detail === 'string' && e.detail) return e.detail
    if (typeof e.title === 'string' && e.title) return e.title
    if (typeof e.message === 'string' && e.message) return e.message
  }
  if (typeof error === 'string') return error
  return 'Неизвестная ошибка'
}

// Доменный код ошибки бэка (`SCENARIO_CONFLICT`, `FLEET_RESERVATION_UNUSABLE`, …):
// httpkit кладёт его полем `code` рядом с `detail`. Текст — человеку, код —
// ветвлению в UI; без кода — пустая строка, а не угадывание по тексту.
export function errorCode(error: unknown): string {
  if (typeof error !== 'object' || error == null) return ''
  const code = (error as { code?: unknown }).code
  return typeof code === 'string' ? code : ''
}

// Точечные ручки дриллдауна отвечают 404 и на «нет такой записи», и на
// терминальную (удалённый юнит, разобранная ячейка) — экран показывает это
// пустым состоянием, а не аварией.
export function isNotFound(error: unknown): boolean {
  return (
    typeof error === 'object' && error != null && (error as { status?: unknown }).status === 404
  )
}
